export const BUSINESS_TYPE_OPTIONS = [
  {
    id: "Sole Proprietorship/DBA",
    value: "Sole Proprietorship/DBA",
  },
  {
    id: "Limited Liability Company (LLC)",
    value: "Limited Liability Company (LLC)",
  },
  { id: "S Corporation", value: "S Corporation" },
  { id: "C Corporation", value: "C Corporation" },
  {
    id: "Non Profit Organization",
    value: "Non Profit Organization",
  },
];
